/* global femcare, OneTrust */

femcare.video.youtubeVideo = {
    videoSelector: '.js-youtube-embed',
    VIDEO_ID: 'youtube-embed-video',
    VIDEO_BUFFERING: 'YOUTUBE_VIDEO_BUFFERING',
    VIDEO_PLAY: 'YOUTUBE_VIDEO_PLAYS',
    VIDEO_PAUSE: 'YOUTUBE_VIDEO_PAUSE',
    VIDEO_STOP: 'YOUTUBE_VIDEO_STOP',
    VIDEO_FINISH: 'YOUTUBE_VIDEO_FINISH',
    $videos: null,
    players: [],
    activePlayer: null,

    init: function () {
        $('.youtube-consent-overlay__text-settings-link').on('click', function () {
            OneTrust.ToggleInfoDisplay();
        });
    },

    loadYoutubeIFrameAPI: function () {
        this.$videos = $(this.videoSelector);

        if (this.$videos.length) {
            $.getScript('https://www.youtube.com/iframe_api', function () {
                this.$videos.show();
                $('.iframe-placeholder').hide();

                femcare.shared.pubsub.publish('YOUTUBE_IFRAME_LOADED');
                this.initYoutubeVideos();
            }.bind(this));
        }
    },

    initYoutubeVideos: function () {
        this.generateId();
        window.YT.ready(this.videoRunner.bind(this));
        femcare.shared.pubsub.subscribe('PLATFORM_INLINE_VIDEO_PLAY', this.stopActivePlayer.bind(this));
        femcare.shared.pubsub.subscribe('PLATFORM_MODAL_VIDEO_PLAY', this.stopActivePlayer.bind(this));
        femcare.shared.pubsub.subscribe('REQUEST_STOP_ACTIVE_PLAYER', this.stopActivePlayer.bind(this));
    },

    /**
     * Return all initialized YouTube videos (expose to other components)
     * @returns {YT} - list of YouTube iframe api players
     */
    getAllPlayers: function () {
        return this.players;
    },

    stopActivePlayer: function () {
        if (this.activePlayer !== null) {
            this.activePlayer.player.stopVideo();

            femcare.shared.pubsub.publish(this.VIDEO_STOP, {
                player: this.activePlayer.player,
                playerId: this.activePlayer.playerId,
                $trigger: this.activePlayer.$trigger
            });

            this.activePlayer = null;
        }
    },

    /**
     * Iframe id
     * @param {any} element
     * @returns {string} - element id attribute
     */
    getIframeId: function (element) {
        return $(element).attr('id');
    },

    /**
     * Set id to html element
     * @param {number} index iteration number from each method
     * @param {HTMLElement} video - wrapper div for iframe
     * @returns {HTMLElement} updated iframe with id attr
     */
    setIdToElement: function (index, video) {
        return video.setAttribute('id', this.VIDEO_ID + '-' + index + '');
    },

    /**
     * Create id on each embed video element
     */
    generateId: function () {
        if (this.$videos.length > 0) {
            this.$videos.each(this.setIdToElement.bind(this));
        }
    },

    /**
     * Callback for iteration over all embed elements
     * @param {number} index - iteration index number
     * @param {HTMLElement} video - embed video element
     */
    youtubeInstanceHandler: function (index, video) {
        var elementId = this.getIframeId(video);
        var youtubeId = $(video).attr('data-youtubeID');
        if (elementId && youtubeId) {
            this.onYouTubeIframeAPIReady(elementId, youtubeId);
        }
    },

    videoRunner: function () {
        this.$videos.each(this.youtubeInstanceHandler.bind(this));
    },

    /**
     * Initalization of Youtube video on page for provided html element by ID
     * @param {string} elementId - iframe id
     * @param {number} youtubeId - id from youtube video
     */
    onYouTubeIframeAPIReady: function (elementId, youtubeId) {
        var player = new YT.Player($('#' + elementId + '')[0], {
            videoId: youtubeId,
            playerVars: { rel: 0 },
            events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            }
        });
        this.players.push(player);
    },

    /**
     * Callback message from YT api when youtube is ready
     * @param {object} event
     */
    onPlayerReady: function (event) {
        // var currentPlayer = this.getIframeId(event.target.getIframe());
    },

    /**
     * Callback for events such as play, pause, ...
     * @param {object} event
     */
    onPlayerStateChange: function (event) {
        var player = event.target;
        var $iframe = $(player.getIframe());
        var playerId = $iframe.attr('id');

        if (event.data === YT.PlayerState.BUFFERING) {
            femcare.shared.pubsub.publish(this.VIDEO_BUFFERING, {
                player: player,
                playerId: playerId,
                $trigger: $iframe
            });
        }

        if (event.data === YT.PlayerState.PLAYING) {

            if (this.activePlayer !== null && this.activePlayer.playerId !== playerId) {
                this.stopActivePlayer();
            }

            this.activePlayer = {
                player: player,
                playerId: playerId,
                $trigger: $iframe
            };

            femcare.shared.pubsub.publish(this.VIDEO_PLAY, {
                player: this.activePlayer.player,
                playerId: this.activePlayer.playerId,
                $trigger: this.activePlayer.$trigger
            });
        }

        if (event.data === YT.PlayerState.PAUSED) {
            femcare.shared.pubsub.publish(this.VIDEO_PAUSE, {
                player: player,
                playerId: playerId,
                $trigger: $iframe
            });

            this.activePlayer = null;
        }

        if (event.data === YT.PlayerState.ENDED) {

            player.stopVideo();
            this.activePlayer = null;

            femcare.shared.pubsub.publish(this.VIDEO_FINISH, {
                player: player,
                playerId: playerId,
                $trigger: $iframe
            });
        }
    }
};